<template>
<div>
  <vx-card class="study-card" vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">

    <vs-list>
      <vs-list-header title="미니 퀴즈를 풀어 보세요" icon-pack="feather" icon="icon-info"></vs-list-header>
      <vs-list-item class="msg-grp-container">
        <vs-chip color="warning mr-0">{{ questionIndex + 1 }} / {{miniQuiz.length}}</vs-chip>
      </vs-list-item>
    </vs-list>

    <div class="lg:p-16 md:p-12 sm:p-8 p-8 rounded-lg mb-base text-center">
      <h1 class="text-primary sentence">{{ currentQuestion.question }}</h1>
    </div>

    <div class="vx-row ml-10">
      <div v-if="currentQuestion.sample1" class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-radio v-model="userAnswer" vs-value="1"><h2 class="sentence">{{currentQuestion.sample1}}</h2></vs-radio>
      </div>
      <div v-if="currentQuestion.sample2" class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-radio v-model="userAnswer" vs-value="2"><h2 class="sentence">{{currentQuestion.sample2}}</h2></vs-radio>
      </div>
      <div v-if="currentQuestion.sample3" class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-radio v-model="userAnswer" vs-value="3"><h2 class="sentence">{{currentQuestion.sample3}}</h2></vs-radio>
      </div>
      <div v-if="currentQuestion.sample4" class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-radio v-model="userAnswer" vs-value="4"><h2 class="sentence">{{currentQuestion.sample4}}</h2></vs-radio>
      </div>
    </div>

    <div class="text-center mt-6">
      <vs-button  @click="onClick" color="success">확인</vs-button>
    </div>
  </vx-card>
</div>
</template>

<script>

import StudyMenuMixin from './StudyMenuMixin'
export default {
  mixins: [StudyMenuMixin],
  components: {
  },
  props: {
    miniQuiz: Array
  },
  data () {
    return {
      questionIndex: 0,
      userAnswer: 0,
      retryCount: 1    
    }
  },
  methods: {
    onNextQuestion () {
      const len = this.miniQuiz.length
      if (this.questionIndex < (len - 1)) {
        this.questionIndex = this.questionIndex + 1
        this.userAnswer = 0
      } else {
        // finish
        this.$emit('onMiniQuizFinished', this.studyResult)
      }
    },
    onClick () {
      
      if (this.currentQuestion.answer !== this.userAnswer) {
        if (this.retryCount < this.retry) {
          this.retryCount++
          this.userAnswer = 0

          this.inCorrect()
        } else {

          this.addResult(this.currentQuestion.question, this.currentQuestion.answer, this.userAnswer)
          //this.miniQuiz[this.questionIndex].userAnswer = this.userAnswer

          setTimeout(function () {
            this.onNextQuestion()
          }.bind(this), 2000)
        }
      } else {
        this.correct()
        this.addResult(this.currentQuestion.question, this.currentQuestion.answer, this.userAnswer)
        //this.miniQuiz[this.questionIndex].userAnswer = this.userAnswer
        setTimeout(function () {
          this.onNextQuestion()
        }.bind(this), 2000)
      }
    }
  },
  watch: {
  },
  computed: {
    currentQuestion () {
      return this.miniQuiz[this.questionIndex]
    }
    // colClass () {
    //   if (this.currentQuestion.sampleNum === 3) {
    //     return 'vx-col md:w-1/3 w-full mb-3'
    //   } else {
    //     return 'vx-col md:w-1/4 w-full mb-3'
    //   }
    // }
  },
  created () {
  },
  mounted () {
  }
}

</script>